import React from "react";
import MenuItem from "@material-ui/core/MenuItem";

import ChipArrayWithInput from "../components/chip_array_with_input";
import ConfirmationSelector from "../components/confirmation_selector";
import DynamicSnackbar from "../components/dynamic_snackbar";
import issueStateUpdateRequest from "../components/panel_update_helper";
import LoadingBackdrop from "../components/loading_backdrop";
import AttributeEditor from "../components/attribute_field";
import SimpleSwitch from "../components/switch";

class ServerPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
      activeInfodocBuild: "",
      availableInfodocBuilds: [],
      patches: {
        android: [],
        ios: [],
      },
      whitelisted_ips: [],
      panels: [],
    };
  }

  render() {
    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>Server</h1>

        {this.state.panels.map(this.renderAttributePanelSection)}

        <div className="panel-section">
          <div>Whitelisted IPs</div>
          <p style={{ fontSize: "0.7rem" }}>
            IP addresses to bypass the maintenance mode.
          </p>
          <div className="panel-sub-section">
            <ChipArrayWithInput
              title="Whitelist IP Addresses"
              childrenFieldName="Whitelisted IP address"
              contents={this.state.whitelisted_ips}
              onChange={(value) => this.handleIPWhitelistChanges(value)}
            />
          </div>
        </div>

        <div className="panel-section">
          <div>Active Infodocs Build</div>
          <ConfirmationSelector
            value={this.state.activeInfodocBuild || ""}
            title="Infodoc Build Selection"
            confirmationMessage="Changing infodoc builds will restart all clients"
            getSelectionInfoCallback={(target) =>
              this.getInfodocMetadata(this, target)
            }
            onChange={this.selectInfodocBuild}
          >
            {this.state.availableInfodocBuilds.sort().map((buildNum, index) => (
              <MenuItem key={"infodoc-select-" + index} value={buildNum}>
                {buildNum}
              </MenuItem>
            ))}
          </ConfirmationSelector>
        </div>

        <div className="panel-section">
          <div>Blacklisted Patches</div>
          <p style={{ fontSize: "0.7rem" }}>
            Patch numbers to blacklist per device type.
          </p>
          <div className="panel-sub-section">
            <ChipArrayWithInput
              title="Blacklist Android Patches"
              childrenFieldName="Blacklisted Android patch"
              contents={this.state.patches.android}
              onChange={(value) =>
                this.handleBlacklistChanges("android", value)
              }
            />
          </div>
          <div className="panel-sub-section">
            <ChipArrayWithInput
              title="Blacklist IOS Patches"
              childrenFieldName="Blacklisted IOS patch"
              contents={this.state.patches.ios}
              onChange={(value) => this.handleBlacklistChanges("ios", value)}
            />
          </div>
        </div>
      </div>
    );
  }

  async componentDidMount() {
    await issueStateUpdateRequest(this, "/server_panel/get_panel_state");
  }

  selectInfodocBuild = async (event) => {
    await issueStateUpdateRequest(
      this,
      "/server_panel/set_infodocs_build",
      { build: event.target.value },
      "post"
    );
  };

  handleBlacklistChanges = async (device_type, patches) => {
    patches = patches.map((str) => {
      return Number(str);
    });
    await issueStateUpdateRequest(
      this,
      "/server_panel/set_blacklisted_patches",
      {
        device_type: device_type,
        blacklisted_patches: patches,
      },
      "post"
    );
  };

  handleIPWhitelistChanges = async (whitelisted_ips) => {
    await issueStateUpdateRequest(
      this,
      "/server_panel/set_whitelisted_ips",
      {
        whitelisted_ips: whitelisted_ips,
      },
      "post"
    );
  };

  getInfodocMetadata = async (panel, build) => {
    let responseData = await issueStateUpdateRequest(
      panel,
      "/server_panel/get_infodoc_metadata/" + build
    );
    return responseData["metadata"];
  };

  renderAttributePanelSection = (panel, i) => {
    return (
      <div className="panel-section" key={"panel-section-" + i}>
        <h1>{panel.sectionName}</h1>
        {panel.attributes.map(this.renderDomElements)}
      </div>
    );
  };

  renderDomElements = (spec) => {
    switch (spec.domElementType) {
      case "INPUT":
        return this.renderInput(spec);
      case "SWITCH":
        return this.renderSwitch(spec);
      default:
        return;
    }
  };

  renderInput = (spec) => {
    return (
      <AttributeEditor
        key={spec.attributeId + spec.value}
        attributeId={spec.attributeId}
        url={spec.setterUrl}
        label={spec.label}
        value={spec.value}
        type={spec.type}
        editable={spec.editable}
        onEdit={this.handleAttributeEdit}
      />
    );
  };

  renderSwitch = (spec) => {
    return (
      <SimpleSwitch
        key={spec.attributeId}
        switchOn={spec.switchOn}
        name={spec.name}
        label={spec.label}
        url={spec.setterUrl}
        onChange={this.handleAttributeEdit}
        editable={spec.editable}
        attributeId={spec.attributeId}
        width={spec.width}
        confirmed={spec.confirmed}
        confirmSpecificStates={spec.confirmSpecificStates}
      />
    );
  };

  handleAttributeEdit = async (url, attributeId, newValue) => {
    await issueStateUpdateRequest(
      this,
      url,
      {
        playerId: this.state.playerId,
        attributeId: attributeId,
        value: newValue,
      },
      "post"
    );
  };
}

export default ServerPanel;
